import { render, staticRenderFns } from "./OutputReportV2.vue?vue&type=template&id=74ae3233&scoped=true&lang=pug&"
import script from "./OutputReportV2.vue?vue&type=script&lang=js&"
export * from "./OutputReportV2.vue?vue&type=script&lang=js&"
import style0 from "./OutputReportV2.vue?vue&type=style&index=0&id=74ae3233&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ae3233",
  null
  
)

export default component.exports